export const FETCH_LATEST_TABS = 'FETCH_LATEST_TABS';

export const fetchLatestTabs = () => {
  return {
    type: FETCH_LATEST_TABS,
    url: window.__env.apiUrl + '/tabs/latest'
  }
};



// WEBPACK FOOTER //
// ./src/actions/homeActions.js